import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import EditCoachingPerformanceForm from "../../components/EditCoachingPerformanceForm/EditCoachingPerformanceForm";
import Layout from "../../components/shared/Layout/Layout";

const EditCoachingPerformancePage = ({ grades, getGradeList, mark }) => {
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`Edit Coaching Performance`}>
        {grades ? (
          <EditCoachingPerformanceForm edit={true} grades={grades} mark={mark} />
        ) : (
          <h3>Loading...</h3>
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(EditCoachingPerformancePage);
